import { AddIcon } from '@assets/icons';
import { GridBox } from '@components/grid-box';
import { useModal } from '@components/modal';
import { Typography } from '@components/typography';
import { Stack, useTheme } from '@mui/material';
import { useWorkspaceContext } from '@navigation/WorkspaceContext';
import posthog from 'posthog-js';
import { GraphsAddGraphModal } from '../graphs';

export const WorkspaceRecentGraphsAddNewGraph = ({ refetch }: { refetch: VoidFunction }) => {
  const { palette } = useTheme();
  const { workspaceId } = useWorkspaceContext();
  const { showModal } = useModal({
    component: GraphsAddGraphModal,
    componentProps: { workspaceId, refetch },
    modalProps: { title: 'New Graph' },
  });

  return (
    <GridBox
      sx={{
        height: '100%',
        width: '100%',
        '& .MuiCardContent-root': { height: '100%', width: '100%' },
      }}
      onClick={() => {
        posthog.capture('user_create-graph_intent', { location: 'workspace-landing' });
        showModal();
      }}
      content={
        <Stack
          justifyContent="center"
          alignItems="center"
          height="100%"
          sx={{ backgroundColor: palette.background.default }}
          gap={1}
        >
          <AddIcon size="30%" />
          <Typography variant="body1">New graph</Typography>
        </Stack>
      }
    />
  );
};
